<ion-header>
  <ion-toolbar>
    <ion-buttons slot="end">
      <ion-button (click)="cancel()" class="closeBtn">
        <ion-icon name="close-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-title>{{ 'general.selectItemTitle' | translate:{type: ('general.cardioCategory' | translate)} }}</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">
  <ion-searchbar [(ngModel)]="searchTerm" [placeholder]="'general.search' | translate"></ion-searchbar>

  <ion-list>
    <ion-item class="ion-no-padding" *ngFor="let category of getFilteredCategories();let i = index">
      <ion-label>{{category.title}}</ion-label>
      <ion-button (click)="selectCategory(category)">{{ 'general.select' | translate }}</ion-button>
    </ion-item>
  </ion-list>

</ion-content>
